module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isRouterAlive && !_vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "img-set": "/static/img/favicon-prod.ico"
    }
  }) : _vm._e(), _vm._v(" "), _c('keep-alive', [(_vm.isRouterAlive && _vm.$route.meta.keepAlive) ? _c('router-view', {
    attrs: {
      "img-set": "/static/img/favicon-prod.ico"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-10d9d441", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-10d9d441","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/App.vue
// module id = 847
// module chunks = 320